import React, { useEffect } from 'react'
import {
  validateName,
  validateEmail,
  mandatorySelectorValidator,
  validatePassword
} from "../../Validations";
import { UserBasicDetails } from './AddUserComponents/UserBasicDetails';
import { useUserContext } from '../../../_context/UserContext';
import { AddedUsers } from './AddUserComponents/AddedUsers';
import './AddUsers.css';

export const AddUsers = () => {
  const { setCurrentPage } = useUserContext();

  useEffect(() => {
    setCurrentPage('Add New System Users');
  }, []);

  return (
    <div className="add-users-page">
      {/* Left: form card */}
      <div className="au-card">
        <div className="au-card-header">
          <div className="au-card-header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <line x1="19" y1="8" x2="19" y2="14" />
              <line x1="22" y1="11" x2="16" y2="11" />
            </svg>
          </div>
          <div>
            <p className="au-card-header-title">Add System User</p>
            <p className="au-card-header-sub">Create a new admin or staff account</p>
          </div>
        </div>
        <div className="au-card-body">
          <UserBasicDetails
            nameValidator={validateName}
            userNameValidator={validateName}
            emailValidator={validateEmail}
            passwordValidator={validatePassword}
            selectValidator={mandatorySelectorValidator}
          />
        </div>
      </div>

      {/* Right: users table card */}
      <div className="au-card">
        <div className="au-card-header">
          <div className="au-card-header-icon">
            <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
              <circle cx="9" cy="7" r="4" />
              <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
              <path d="M16 3.13a4 4 0 0 1 0 7.75" />
            </svg>
          </div>
          <div>
            <p className="au-card-header-title">System Users</p>
            <p className="au-card-header-sub">Browse and manage existing accounts</p>
          </div>
        </div>
        <div className="au-card-body">
          <AddedUsers />
        </div>
      </div>
    </div>
  );
};
